/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
// import { territories } from '../constants/territories';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

import { dialLayerOptions } from '../styles/map';

// const helpStations = require('../data/helpStations.json');

// MapBox token
const mapboxAccessToken = // process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
  'pk.eyJ1IjoiamVhbmNhcnJpbGxvIiwiYSI6ImNqd2oweXVxNDBlbDYzeXFreXFid3Z5dTkifQ.dTPb1xS_kieqTkPpTxIa5Q';
mapboxgl.accessToken = mapboxAccessToken;

// Prevents MapBox from spamming console with missing tiles...
const consoleerror = console.error;
console.error = function (err) {
  if (err.status !== undefined && err.status === 403) {
    return;
  } else if (err.message !== undefined && err.message === 'Failed to fetch') {
    return;
  } else {
    consoleerror(err);
  }
};

export const MapContext = React.createContext();

class MapProvider extends Component {
  constructor(props) {
    super(props);
    this.currentCoords = {
      // lng: territories[0].lng,
      // lat: territories[0].lat,
      // zoom: territories[0].zoom,
      lng: -3.341199,
      lat: 47.842647,
      zoom: 7,
    };
    this.map = null;
    this.state = {
      setMap: this.setMap,
      flyTo: this.flyTo,
    };
  }

  setMap = (mapContainer) => {
    const initializeMap = (mapContainer) => {
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(this.onUserLocation);
      // }
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/light-v10?optimize=true',
        center: [this.currentCoords.lng, this.currentCoords.lat],
        zoom: this.currentCoords.zoom,
      });
      map.resize();
      // disable map rotation using right click + drag
      map.dragRotate.disable();
      // disable map rotation using touch rotation gesture
      map.touchZoomRotate.disableRotation();

      // Initialize the geocoder
      const geocoder = new MapboxGeocoder({
        accessToken: mapboxAccessToken,
        mapboxgl: mapboxgl,
        marker: false,
        position: 'top-right',
        clearOnBlur: true,
        language: 'FR',
        placeholder: 'Rechercher',
      });

      // Add the geocoder to the map
      map.addControl(geocoder);

      // Add zoom and rotation controls to the map.
      map.addControl(
        new mapboxgl.NavigationControl({
          showCompass: false,
        }),
        'bottom-right'
      );

      // Add user location to the map
      // const geolocate = new mapboxgl.GeolocateControl(
      //   new mapboxgl.GeolocateControl({
      //     positionOptions: {
      //       enableHighAccuracy: true,
      //     },
      //     trackUserLocation: true,
      //   })
      // );
      // map.addControl(geolocate);

      // geolocate.on('geolocate', function (e) {
      //   map.flyTo({
      //     center: [e.coords.longitude, e.coords.latitude],
      //     zoom: 8,
      //   });
      // });

      map.on('load', () => {
        // Activates user geolocation on map load
        // geolocate.trigger();

        const layers = map.getStyle().layers;
        // Find the index of the first symbol layer in the map style
        // Used to add layers below labels
        let firstSymbolId;
        for (let i = 0; i < layers.length; i++) {
          if (layers[i].type === 'symbol') {
            firstSymbolId = layers[i].id;
            break;
          }
        }
        this.map = map;

        map.addLayer(
          {
            id: 'dial-cover',
            source: {
              type: 'vector',
              tiles: [
                `https://a.tiles.mobilecoveragemap.com/dial-cover/{z}/{x}/{y}.pbf`,
                `https://b.tiles.mobilecoveragemap.com/dial-cover/{z}/{x}/{y}.pbf`,
              ],
              // minzoom: 8,
              maxzoom: 12,
            },
            'source-layer': 'dial-cover',
            ...dialLayerOptions,
          },
          firstSymbolId
        );

        // map.addSource('help-stations', {
        //   type: 'geojson',
        //   data: helpStations,
        // });

        // map.addLayer({
        //   id: 'help-stations',
        //   type: 'symbol',
        //   source: 'help-stations',
        //   layout: {
        //     'icon-image': 'hospital-15',
        //   },
        // });
      });

      // When a click event occurs on a feature in the places layer, open a popup at the
      // location of the feature, with description HTML from its properties.
      // map.on('click', 'help-stations', function(e) {
      //   const properties = e.features[0].properties;
      //   console.log({ properties });

      //   // Ensure that if the map is zoomed out such that multiple
      //   // copies of the feature are visible, the popup appears
      //   // over the copy being pointed to.
      //   // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //   //   coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      //   // }

      //   // new mapboxgl.Popup()
      //   //   .setLngLat(coordinates)
      //   //   .setHTML(description)
      //   //   .addTo(map);
      // });

      // // Change the cursor to a pointer when the mouse is over the help-stations layer.
      // map.on('mouseenter', 'help-stations', function() {
      //   map.getCanvas().style.cursor = 'pointer';
      // });

      // // Change it back to a pointer when it leaves.
      // map.on('mouseleave', 'help-stations', function() {
      //   map.getCanvas().style.cursor = '';
      // });
    };
    if (!this.map) initializeMap(mapContainer);
  };

  // handleFilters = () => {
  //   const { filters } = this.state;
  //   const { map } = this;
  //   // const visibility = map.getLayoutProperty(name, "visibility");
  //   const filterKeys = Object.keys(filters);
  //   const newFilters = { ...filters };
  //   for (const filter of filterKeys) {
  //     map.setLayoutProperty(
  //       filter,
  //       'visibility',
  //       filters[filter] ? 'none' : 'visible'
  //     );
  //     newFilters[filter] = !filters[filter];
  //   }
  //   this.setState({ filters: newFilters });
  // };

  flyTo = (point) => {
    const { map } = this;
    const { lng, lat, zoom } = point;
    map.flyTo({
      center: [lng, lat],
      zoom,
      maxDuration: 1500,
      essential: true,
    });
  };

  // onUserLocation = userLocation => {
  //   const { map } = this.state;
  //   console.log({ userLocation, map });
  //   if (map) {
  //     map.flyTo({
  //       center: [userLocation.coords.longitude, userLocation.coords.latitude],
  //       zoom: 10,
  //       maxDuration: 0,
  //       essential: true,
  //     });
  //   } else {
  //     this.currentCoords = {
  //       lng: userLocation.coords.longitude,
  //       lat: userLocation.coords.latitude,
  //       zoom: 8,
  //     };
  //   }
  // };

  render() {
    const { children } = this.props;
    const { map } = this;
    return (
      <MapContext.Provider value={{ ...this.state, map }}>
        {children}
      </MapContext.Provider>
    );
  }
}

export default MapProvider;
